'use client';

import { AlertDialog } from '@tuic/web-compositions/shared/AlertDialog';
import { ButtonGroup } from '@tuic/web-compositions/core/ButtonGroup';
import { TextButton } from '@tuic/web-compositions/core/TextButton';
import { FC, useState } from 'react';
import { useClientTranslation } from '@lib/i18n/client';

type Props = {
  getIframeUrl?: () => URL;
};

export const Mxp365DebugFooter: FC<Props> = ({ getIframeUrl }) => {
  const { t } = useClientTranslation();
  const [urlVisible, setUrlVisible] = useState(false);

  const handleClick = () => {
    setUrlVisible(true);
  };

  const handleClose = () => setUrlVisible(false);

  return (
    <div className="px-4 flex items-center">
      <ButtonGroup>
        <TextButton onClick={handleClick}>
          {t('Iframe-URL anzeigen')}
        </TextButton>
      </ButtonGroup>
      <AlertDialog
        open={urlVisible}
        onOpenChange={handleClose}
        title={t('Iframe-URL des MXP365-Dialogs')}
        actions={[{ title: t('Schließen') }]}
      >
        <code className="break-words">
          {getIframeUrl?.().toString() ?? t('URL nicht verfügbar.')}
        </code>
      </AlertDialog>
    </div>
  );
};
